import { render, staticRenderFns } from "./OrderBinItem.vue?vue&type=template&id=e10be3da&scoped=true"
import script from "./OrderBinItem.vue?vue&type=script&lang=js"
export * from "./OrderBinItem.vue?vue&type=script&lang=js"
import style0 from "./OrderBinItem.vue?vue&type=style&index=0&id=e10be3da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10be3da",
  null
  
)

export default component.exports